import { render, staticRenderFns } from "./DocumentChangeRequest.vue?vue&type=template&id=21a12deb&scoped=true&"
import script from "./DocumentChangeRequest.vue?vue&type=script&lang=js&"
export * from "./DocumentChangeRequest.vue?vue&type=script&lang=js&"
import style0 from "./DocumentChangeRequest.vue?vue&type=style&index=0&id=21a12deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a12deb",
  null
  
)

export default component.exports